const site_set_type = {
  label: '广告版位',
  type: 'radio-group',
  isButton: true,
  rules: {
    required: true,
    message: '请选择广告版位',
    trigger: ['change'],
  },
  options: [
    { label: '自动版位', value: 1 },
    { label: '选择特定版位', value: 2 },
  ],
  value: 1,
};

const site_sets = {
  label: ' ',
  type: 'checkbox-group',
  options: [],
  isBox: true,
  hidden: true,
  value: [],
};

/**
 * 广告：广告版位配置
 */
export {
  site_set_type, // 广告版位类型
  site_sets, // 广告版位
};
